import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import PartnerSidebar from "./scenes/partnerSidebar";
import Dashboard from "./scenes/dashboard";
import AdsDashboard from "./scenes/adsDashboard";
import PartnerDashboard from "./scenes/partnerDashboard";
import PartnerProducts from "./scenes/partnerProducts";
import PartnerProductDetails from "./scenes/partnerProductDetails";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import LoginForm from "./scenes/login";
import PartnerLoginForm from "./scenes/partnerLogin";
import TapLoginForm from "./scenes/tapLogin";
import Landing from "./scenes/landing";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import ProtectedRoute from "./components/protection";
import AddProduct from "./scenes/addProduct";
import AddCompany from "./scenes/addCompany";
import ProductList from "./scenes/productList";
import Companies from "./scenes/companies";
import TransferBookings from "./scenes/transferBookings";
import LoungeBookings from "./scenes/loungeBookings";
import TapBookings from "./scenes/tapBookings";
import DailyTap from "./scenes/dailyTap";
import Flights from "./scenes/flights";
import Discount from "./scenes/discount.jsx";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const location = useLocation(); // Get current route

  // Hide Topbar/Sidebar on landing and login pages
  const isLoginPage = location.pathname === "/" || 
                      location.pathname === "/admin-login" || 
                      location.pathname === "/partner-login" ||
                      location.pathname === "/tap-login";

  // Check if current route is a partner route
  const isPartnerRoute = location.pathname.startsWith("/partner-");

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {!isLoginPage && (isPartnerRoute ? <PartnerSidebar isSidebar={isSidebar} /> : <Sidebar isSidebar={isSidebar} />)}
          <main className="content">
            {!isLoginPage && <Topbar setIsSidebar={setIsSidebar} />}
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin-login" element={<LoginForm />} />
              <Route path="/partner-login" element={<PartnerLoginForm />} />
              <Route path="/tap-login" element={<TapLoginForm />} />
              <Route path="/dashboard" element={<ProtectedRoute><Team /></ProtectedRoute>} />
              <Route path="/ads-dashboard" element={<ProtectedRoute><AdsDashboard /></ProtectedRoute>} />
              <Route path="/partner-dashboard" element={<ProtectedRoute><PartnerDashboard /></ProtectedRoute>} />
              <Route path="/partner-products" element={<ProtectedRoute><PartnerProducts /></ProtectedRoute>} />
              <Route path="/partner-products/:productId" element={<ProtectedRoute><PartnerProductDetails /></ProtectedRoute>} />
              <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
              <Route path="/transfer-bookings" element={<ProtectedRoute><TransferBookings /></ProtectedRoute>} />
              <Route path="/lounge-bookings" element={<ProtectedRoute><LoungeBookings /></ProtectedRoute>} />
              <Route path="/tap-bookings" element={<ProtectedRoute><TapBookings /></ProtectedRoute>} />
              <Route path="/daily-tap" element={<ProtectedRoute><DailyTap /></ProtectedRoute>} />
              <Route path="/flights" element={<ProtectedRoute><Flights /></ProtectedRoute>} />
              <Route path="/discount" element={<ProtectedRoute><Discount /></ProtectedRoute>} />
              <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
              <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
              <Route path="/form" element={<ProtectedRoute><Form /></ProtectedRoute>} />
              <Route path="/add-product" element={<ProtectedRoute><AddProduct /></ProtectedRoute>} />
              <Route path="/add-company" element={<ProtectedRoute><AddCompany /></ProtectedRoute>} />
              <Route path="/product-list" element={<ProtectedRoute><ProductList /></ProtectedRoute>} />
              <Route path="/companies" element={<ProtectedRoute><Companies /></ProtectedRoute>} />
              <Route path="/bar" element={<ProtectedRoute><Bar /></ProtectedRoute>} />
              <Route path="/pie" element={<ProtectedRoute><Pie /></ProtectedRoute>} />
              <Route path="/line" element={<ProtectedRoute><Line /></ProtectedRoute>} />
              <Route path="/faq" element={<ProtectedRoute><FAQ /></ProtectedRoute>} />
              <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
              <Route path="/geography" element={<ProtectedRoute><Geography /></ProtectedRoute>} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;